/* eslint-disable no-undef */
/**
 * Append Botmaker Document into current Document.
 * @return {void}
 */
const initializeFloatingChat = () => {
  const js = document.createElement('script');
  js.type = 'text/javascript';
  js.async = 1;
  js.src = 'https://go.botmaker.com/rest/webchat/p/4GK3B3170V/init.js';
  document.body.appendChild(js);
};

/**
 * Maximize chat.
 * @return {void}
 */
const openFloatingChat = () => bmMaximize();

/**
 * Minimize chat.
 * @return {void}
 */
const closeFloatingChat = () => bmMinimize();

/**
 * Set variables in botmaker chat, if it succeeds it returns true
 * otherwise it returns false
 * @param {object} variables
 * @return {boolean}
 */
const setVariables = (variables) => {
  try {
    bmSetVariables(variables);
    return true;
  } catch (error) {
    return false;
  }
};

/**
 * Hide chat.
 * @return {void}
 */
const hideFloatingChat = () => bmHide();

/**
 * Show chat.
 * @return {void}
 */
const showFloatingChat = () => bmShow();

/**
 * Maximize and show chat.
 * @return {void}
 */
const showChat = () => {
  bmMaximize();
  bmShow();
};

/**
 * Minimize and hide chat.
 * @return {void}
 */
const hideChat = () => {
  bmMinimize();
  bmHide();
};

export default {
  initializeFloatingChat,
  openFloatingChat,
  closeFloatingChat,
  hideFloatingChat,
  setVariables,
  showFloatingChat,
  showChat,
  hideChat,
};
